import { createMuiTheme } from "@material-ui/core";

// tasteck ブランドカラー (ドライバーモバイル向け、夜間運転合間の視認性重視)
//
// 基本方針:
// - 運転合間 + 夜間使用が多い → 暗所でも眩しくない配色
// - primary: 深い teal (staff-app / cast-app と統一)
// - secondary: 赤 (到着/緊急ステータス等)
// - 背景は cool グレー (目の負担軽減)
const theme = createMuiTheme({
  palette: {
    primary: {
      light: "#0d9488",
      main: "#115e59",
      dark: "#0f4945",
      contrastText: "#ffffff",
    },
    secondary: {
      light: "#fca5a5",
      main: "#dc2626",
      dark: "#b91c1c",
      contrastText: "#ffffff",
    },
    error: {
      main: "#dc2626",
    },
    warning: {
      main: "#d97706",
    },
    success: {
      main: "#15803d",
    },
    info: {
      main: "#0d9488",
    },
    text: {
      primary: "#1a2332",
      secondary: "#5e6a7c",
    },
    background: {
      default: "#f3f5f7",
      paper: "#fbfcfd",
    },
    divider: "rgba(0, 0, 0, 0.08)",
  },
  typography: {
    htmlFontSize: 10,
    fontSize: 14,
    body1: {
      fontSize: "1.4rem",
    },
  },
  props: {
    MuiButtonBase: {
      disableRipple: true,
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 479,
      md: 768,
      lg: 959,
      xl: 1112,
    },
  },
});

export default theme;
